import { combinedApi as api } from '@redux/combinedApi';
export const addTagTypes = ['LimitSet'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getLimitSetById: build.query<GetLimitSetByIdApiResponse, GetLimitSetByIdApiArg>({
        query: (queryArg) => ({ url: `/LimitSet/${queryArg}` }),
        providesTags: ['LimitSet'],
      }),
      getLimitSetGetAll: build.query<GetLimitSetGetAllApiResponse, GetLimitSetGetAllApiArg>({
        query: () => ({ url: `/LimitSet/get-all` }),
        providesTags: ['LimitSet'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as limitSetApi };
export type GetLimitSetByIdApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoLimitSetExternalDto;
export type GetLimitSetByIdApiArg = number;
export type GetLimitSetGetAllApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoLimitSetExternalDto;
export type GetLimitSetGetAllApiArg = void;
export type ApiCommonExternalDtoLimitSetExternalDto = {
  id?: number;
  name: string;
  isDefault?: boolean;
};
export type ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoLimitSetExternalDto = {
  externalDto?: ApiCommonExternalDtoLimitSetExternalDto;
  externalDtos?: ApiCommonExternalDtoLimitSetExternalDto[] | null;
};
export const {
  useGetLimitSetByIdQuery,
  useLazyGetLimitSetByIdQuery,
  useGetLimitSetGetAllQuery,
  useLazyGetLimitSetGetAllQuery,
} = injectedRtkApi;
